import {
  Box,
  Flex,
  Picture,
  RatioContainer,
  Typography,
} from "@jewlr/storybook/core"
import React from "react"
import { Link } from "react-router-dom"
import styled from "styled-components"

import { jewlr_t } from "helpers/application"
import { to_currency } from "helpers/number"
import VibeForm from "jewlr/main/vibe/vibe-form"

const TextBox = styled(Box).attrs((props) => ({
  top: "8%",
  ...props,
}))`
  position: absolute;
  text-decoration: none;
  bottom: -2px;
  ${(props) => props.theme.mediaQueries.tablet`
    bottom: auto;
    top: 50%;
    transform: translateY(-50%);
  `}
`
const TextCta = styled(Typography).attrs((props) => ({
  as: Link,
  color: "black",
  fontSize: "18px",
  fontWeight: "300",
  mb: 1,
  ...props,
}))`
  text-decoration: underline;
  :hover,
  :active {
    text-decoration: none;
  }
`
const SectionTitle = styled(Typography).attrs((props) => ({
  color: "black",
  fontSize: "26px",
  fontWeight: "300",
  mb: "10px",
  ...props,
}))``

const SectionText = styled(Typography)`
  font-weight: 300;
  margin-bottom: 18px;
`

const Vibe = () => {
  return (
    <div>
      <RatioContainer
        mb={{ _: 4, desktop: 6 }}
        pb={{ _: "117.99%", tablet: "19.11%" }}
      >
        <div>
          <Box
            display={{ tablet: "flex" }}
            justifyContent="center"
            position="relative"
          >
            <Picture
              alt=""
              fallback={require("images/vibe/desktop_2x.jpg")}
              lazyload={false}
              srcSet={[
                {
                  media: "(max-width: 767px)",
                  sizes: "100vw",
                  srcSet: `
       ${require("images/vibe/mobile.jpg")} 767w,
       ${require("images/vibe/mobile_2x.jpg")} 1534w
    `,
                },
                {
                  media: "(min-width: 768px)",
                  sizes: "100vw",
                  srcSet: `
       ${require("images/vibe/desktop.jpg")} 1920w,
       ${require("images/vibe/desktop_2x.jpg")} 3840w,
       ${require("images/vibe/tablet.jpg")} 1005w,
       ${require("images/vibe/tablet_2x.jpg")} 2010w
    `,
                },
              ]}
              width="100%"
            />
            <Box contain height="100%" position="absolute" top="0" width="100%">
              <TextBox
                right={{ tablet: "6%" }}
                textAlign="center"
                width={{ _: "100%", tablet: "280px" }}
              >
                <Typography
                  fontSize="32px"
                  fontWeight="normal"
                  mb={{ _: "8px", tablet: "12px" }}
                >
                  Welcome to Jewlr!
                </Typography>
                <Typography fontSize={{ _: 3, tablet: "18px" }} light mb={2}>
                  Create the perfect, custom-made gifts
                  <br />
                  for you and your wedding party.
                </Typography>
              </TextBox>
            </Box>
          </Box>
        </div>
      </RatioContainer>
      <Box contain pb={3} px={3}>
        <Box mb={3}>
          <Box
            mx="auto"
            textAlign="center"
            width={{ _: "100%", tablet: "65%" }}
          >
            <Typography fontSize="26px" mb={2}>
              Congratulations on your engagement!{" "}
            </Typography>
            <Typography fontSize={16} lineHeight="22px" mb={4}>
              As an early wedding gift, we’d like to offer you the chance to win{" "}
              {to_currency(200)} to use towards a {sl.config.site_title}{" "}
              purchase. Sign up with your name and email address to enter our
              contest, and as a bonus gift, we’ll send you a special promo code
              to save 20% on your next purchase.
            </Typography>
          </Box>

          <VibeForm mailList="wedding_vibes_20180904" promoCode="JEWLRWB20" />
        </Box>
        <Typography
          fontSize="26px"
          fontWeight="normal"
          my={2}
          textAlign="center"
        >
          Celebrate With Unique, {jewlr_t("terms.Personalize")}d{" "}
          {jewlr_t("terms.Jewelry")}
        </Typography>
        <Flex
          alignItems="center"
          flexDirection={{ _: "column", tablet: "row" }}
          gutter={2}
          justifyContent="center"
          mb={{ _: "40px", tablet: 0 }}
        >
          <Box flexBasis={{ _: "100%", tablet: "50%" }}>
            <Picture
              alt=""
              fallback={require("images/vibe/bridalset_desktop_2x.jpg")}
              lazyload={false}
              srcSet={[
                {
                  media: "(max-width: 767px)",
                  sizes: "100vw",
                  srcSet: `
           ${require("images/vibe/bridalset_mobile.jpg")} 767w,
           ${require("images/vibe/bridalset_mobile_2x.jpg")} 1534w
        `,
                },
                {
                  media: "(min-width: 768px)",
                  sizes: "100vw",
                  srcSet: `
           ${require("images/vibe/bridalset_desktop.jpg")} 470w,
           ${require("images/vibe/bridalset_desktop_2x.jpg")} 940w
        `,
                },
              ]}
              width="100%"
            />
          </Box>
          <Box flexBasis={{ _: "100%", tablet: "40%" }}>
            <SectionTitle>Wedding Bands</SectionTitle>
            <SectionText fontSize={16} mb={2}>
              {jewlr_t("terms.Personalize")} the perfect band to express your
              love and personal style – handcrafted just for you.
            </SectionText>
            <Flex justifyContent="space-between">
              <TextCta data-lc="vibe" to="/bands-for-her">
                Shop Now
              </TextCta>
            </Flex>
          </Box>
        </Flex>

        <Flex
          alignItems="center"
          flexDirection={{ _: "column-reverse", tablet: "row" }}
          gutter={2}
          justifyContent="center"
          mb={{ _: "40px", tablet: 0 }}
        >
          <Box flexBasis={{ _: "100%", tablet: "40%" }}>
            <SectionTitle>Gifts For Bridesmaids</SectionTitle>
            <SectionText>
              Meaningful and stylish – show them how important they are with the
              perfect {jewlr_t("terms.personalize")}d gift.
            </SectionText>

            <TextCta data-lc="vibe" to="/bridesmaids-gifts">
              Shop Now
            </TextCta>
          </Box>
          <Box flexBasis={{ _: "100%", tablet: "50%" }}>
            <Picture
              alt=""
              fallback={require("images/vibe/necklace_desktop_2x.jpg")}
              lazyload={false}
              srcSet={[
                {
                  media: "(max-width: 767px)",
                  sizes: "100vw",
                  srcSet: `
             ${require("images/vibe/necklace_mobile.jpg")} 767w,
             ${require("images/vibe/necklace_mobile_2x.jpg")} 1534w
          `,
                },
                {
                  media: "(min-width: 768px)",
                  sizes: "100vw",
                  srcSet: `
             ${require("images/vibe/necklace_desktop.jpg")} 497w,
             ${require("images/vibe/necklace_desktop_2x.jpg")} 994w
          `,
                },
              ]}
              width="100%"
            />
          </Box>
        </Flex>

        <Flex
          alignItems="center"
          flexDirection={{ _: "column", tablet: "row" }}
          gutter={2}
          justifyContent="center"
        >
          <Box flexBasis={{ _: "100%", tablet: "50%" }}>
            <Picture
              alt=""
              fallback={require("images/vibe/cufflinks_desktop_2x.jpg")}
              lazyload={false}
              srcSet={[
                {
                  media: "(max-width: 767px)",
                  sizes: "100vw",
                  srcSet: `
           ${require("images/vibe/cufflinks_mobile.jpg")} 767w,
           ${require("images/vibe/cufflinks_mobile_2x.jpg")} 1534w
        `,
                },
                {
                  media: "(min-width: 768px)",
                  sizes: "100vw",
                  srcSet: `
           ${require("images/vibe/cufflinks_desktop.jpg")} 470w,
           ${require("images/vibe/cufflinks_desktop_2x.jpg")} 940w
        `,
                },
              ]}
              width="100%"
            />
          </Box>

          <Box
            flexBasis={{ _: "100%", tablet: "40%" }}
            mb={{ _: "40px", tablet: "0px" }}
          >
            <SectionTitle>Gifts For Groomsmen</SectionTitle>
            <SectionText>
              Say thank you for being part of your big day with a thoughtful
              gift, {jewlr_t("terms.personalize")}d just for them.
            </SectionText>
            <TextCta data-lc="vibe" to="/cufflinks">
              Shop Now
            </TextCta>
          </Box>
        </Flex>
      </Box>
    </div>
  )
}

export default Vibe
